module.exports = __webpack_public_path__ + "img/con_2.3b6d06fc.svg";